import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '@core/Abstract/config.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { parseInt } from 'lodash';
declare var $: any;

import { PerfectScrollbarConfigInterface } from 'ngx-om-perfect-scrollbar';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  constructor(public router: Router, 
              private eventsEmitterService: EventsEmitterService,
              private configService: ConfigService
             ) {}

  tabStatus = 'justified';

  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;

  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: 'overlay', // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin6', // six possible values: skin(1/2/3/4/5/6/7)
    sidebarbg: 'skin7', // six possible values: skin(1/2/3/4/5/6/7)
    logobg: 'skin6' // six possible values: skin(1/2/3/4/5/6/7)
  };

  Logo() {
    this.expandLogo = !this.expandLogo;
  }

  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate(['/menu/home']);
    }
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
    this.eventsEmitterService.languageChange.subscribe(() => {
            const textDirection = "ar-AE" === this.configService.getCurrentLocaleStr()? 'rtl':'ltr';
            this.options.dir = textDirection;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleSidebar();
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
      case 'iconbar':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      case 'overlay':
        if (this.innerWidth < 767) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  themeChange(){
    if(this.options.theme == 'light'){
      this.options.theme = 'dark';
      //also set nav / sidebar styles
      this.options.logobg = 'skin5';
      this.options.navbarbg = 'skin5';
      this.options.sidebarbg = 'skin4';
    } else {
      this.options.theme = 'light';
      //also set nav / sidebar styles
      this.options.logobg = 'skin6';
      this.options.navbarbg = 'skin6';
      this.options.sidebarbg = 'skin7';
    }
  }
}
